export default "__VITE_ASSET__ChIrtAIZ__"